namespace $.$$ {

	export class $hyoo_intern_cabinet_curator extends $.$hyoo_intern_cabinet_curator {

	}

}
